var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "home-post-title-container" },
        [
          _c("div", { staticClass: "title-txt", class: [_vm.lang] }, [
            _vm._v(_vm._s(_vm.$t("postTitleTxt"))),
          ]),
          _c(
            "a-button",
            {
              staticClass: "post-title-btn",
              class: [_vm.lang],
              attrs: { type: "primary", loading: _vm.btnLoading },
              on: { click: _vm.publishPost },
            },
            [_vm._v(_vm._s(_vm.$t("postTitleBtnTxt")))]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }